export default __webpack_public_path__ + "static/media/nodeJS.aff6323e.svg";